<style scoped>

  img {
    margin-top: 40px;
    margin-bottom: -15px !important;
  }

  h1 {
    font-size: 90px;
  }

  h2 {
    font-size: 30px;
    color: #767676;
    margin-top: -20px;
    margin-bottom: 35px;
  }

</style>

<template>

  <div class="ui center aligned basic segment">
    <img class="ui centered medium image" src="/assets/images/logo.png">
    <h1>404</h1>
    <h2>Página não encontrada</h2>
    <button class="ui huge icon button" @click="$router.push('/')">
      <i class="home icon"></i>
      Página Inicial
    </button>
  </div>

</template>

<script>
  export default {
    name: "NotFoundPage",
  }
</script>


